import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import * as ProjectActions from '../actions/projects.actions';
import { ProjectService } from '../../services/project.service';


@Injectable({ providedIn: 'root' })
export class ProjectsEffects {
    private projectService = inject(ProjectService);
    private actions$ = inject(Actions);

    loadProjects$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectActions.loadProjects),
            switchMap(() =>
                this.projectService.getProjects().pipe(
                    map(projects => ProjectActions.loadProjectsSuccess({ projects })),
                    catchError(error => of(ProjectActions.loadProjectsFailure({ error })))
                )
            )
        )
    );

    loadProjectsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.loadProjectsSuccess),
                tap(({ projects }) => {
                })
            ),
        { dispatch: false }
    );

    loadProjectsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.loadProjectsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
    createProject$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectActions.createProject),
            switchMap(({ project }) =>
                this.projectService.createProject(project).pipe(
                    map(createdProject => ProjectActions.createProjectSuccess({ project: createdProject })),
                    catchError(error => of(ProjectActions.createProjectFailure({ error })))
                )
            )
        )
    );
    createProjectSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.createProjectSuccess),
                tap(({ project }) => {
                })
            ),
        { dispatch: false }
    );
    createProjectFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.createProjectFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
    updateProject$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectActions.updateProject),
            switchMap(({ project }) =>
                this.projectService.updateProject(project.id, project).pipe(
                    map(updatedProject => ProjectActions.updateProjectSuccess({ project: updatedProject })),
                    catchError(error => of(ProjectActions.updateProjectFailure({ error })))
                )
            )
        )
    );
    updateProjectSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.updateProjectSuccess),
                tap(({ project }) => {
                })
            ),
        { dispatch: false }
    );
    updateProjectFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.updateProjectFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
    deleteProject$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectActions.deleteProject),
            switchMap(({ projectId }) =>
                this.projectService.deleteProject(projectId).pipe(
                    map(() => ProjectActions.deleteProjectSuccess({ projectId })),
                    catchError(error => of(ProjectActions.deleteProjectFailure({ error })))
                )
            )
        )
    );
    deleteProjectSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.deleteProjectSuccess),
                tap(({ projectId }) => {
                })
            ),
        { dispatch: false }
    );
    deleteProjectFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ProjectActions.deleteProjectFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );

}